import React from 'react';
import { titleCase, formatDate } from 'modules/shared/utils';
import { CustomerSummaryProps } from './customer-summary-type';

import styles from './customer-summary-component.module.css';

export const CustomerSummary: React.FC<CustomerSummaryProps> = ({
    lastName,
    firstName,
    weddingDate,
}: CustomerSummaryProps) => {
    const formattedLastName = lastName ? lastName.toUpperCase() : '';
    const formattedFirstName = firstName ? titleCase(firstName) : '';
    const formattedWeddingDate = `${weddingDate ? `Mariage prévu le ${formatDate(weddingDate)}` : ''}`;
    return (
        <div className={styles.rootContainer}>
            <div className={styles.label}>{`${formattedLastName} ${formattedFirstName}`}</div>
            <div className={styles.label}>{formattedWeddingDate}</div>
        </div>
    );
};
